import { render, staticRenderFns } from "./editMiniGame.vue?vue&type=template&id=161f4505&lang=pug"
import script from "./editMiniGame.vue?vue&type=script&lang=js"
export * from "./editMiniGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports